import { MaintenanceImport } from './Import'
const { RoutesMap, HierarchyList, ScheduledList, CreateMaintenance } = MaintenanceImport

const MaintenanceRoute = () => {
    return [
        {
            path: RoutesMap.HIERARCHY.path,
            element: <HierarchyList />
        },
        {
            path: RoutesMap.SCHEDULED_LIST.path,
            element: <ScheduledList />
        },
        {
            path: RoutesMap.CREATE_MAINTENANCE.path,
            element: <CreateMaintenance />
        },
    ]
}

export default MaintenanceRoute;